import classNames from 'classnames';
import { MouseEvent } from 'react';
import ArrowSq from '../../icons/ArrowSq';
import IconButton from '../IconButton';
import styles from './styles/styles.module.scss';

export type ArrowStyle = 'standard' | 'external' | 'subtle' | 'subtle-with-standard-arrows';
type ArrowButtonProps = {
  className?: string;
  onClick: () => void;
  uniqueId: string;
  title: string;
  variant: ArrowStyle;
  disabled?: boolean;
  ariaLabel?: string;
};

const variantsToClassNames = {
  standard: styles.square,
  external: styles.external,
  subtle: styles.subtle,
  'subtle-with-standard-arrows': styles.subtleWithStandardArrows
};

const ArrowButton = (orientation: 'left' | 'right') =>
  function ({ className, onClick, uniqueId, title, variant, disabled, ariaLabel }: ArrowButtonProps) {
    return (
      <IconButton
        className={classNames(styles[`${orientation}Arrow`], variantsToClassNames[variant], className)}
        icon={{ Component: ArrowSq, orientation }}
        onClick={(e?: MouseEvent) => {
          e?.preventDefault();
          e?.stopPropagation();
          onClick();
        }}
        disabled={disabled}
        title={title}
        ariaLabel={ariaLabel}
        testId={`${uniqueId}_ArrowButton_${orientation}`}
        size={['subtle', 'subtle-with-standard-arrows'].includes(variant) ? 'sm' : 'md'}
        variant={['subtle', 'subtle-with-standard-arrows'].includes(variant) ? 'transparent' : 'elevated'}
      />
    );
  };

export const LeftArrow = ArrowButton('left');
export const RightArrow = ArrowButton('right');
